var TopupStatus;
(function (TopupStatus) {
    TopupStatus["Pending"] = "PENDING";
    TopupStatus["Completed"] = "COMPLETED";
    TopupStatus["Failed"] = "FAILED";
})(TopupStatus || (TopupStatus = {}));
export default TopupStatus;
